module.exports = __webpack_public_path__ + "assets/images/template/image-background-header-desktop.jpg?v=024475ea";